// "Descartar pedido?" ao fechar o popup com escolhas feitas.
import { Dialog, DialogContent } from "../../../components/ui/dialog";

export default function DialogoDescartar({ showDiscardConfirm, setShowDiscardConfirm, onClose }) {
  return (
    <Dialog open={showDiscardConfirm} onOpenChange={setShowDiscardConfirm}>
      <DialogContent hideClose className="sm:max-w-xs p-0 gap-0 overflow-hidden bg-zinc-900 border-0 rounded-2xl w-[85vw] sm:w-full">
        <div className="p-6 text-center">
          <div className="text-4xl mb-3">⚠️</div>
          <h3 className="text-lg font-bold text-zinc-100 mb-2">Descartar pedido?</h3>
          <p className="text-sm text-zinc-400 mb-6">Se você sair agora, as escolhas feitas serão perdidas.</p>
          <div className="flex gap-3">
            <button onClick={() => setShowDiscardConfirm(false)} className="flex-1 h-12 rounded-full bg-zinc-700 hover:bg-zinc-600 text-zinc-100 font-bold text-sm transition-colors">Continuar editando</button>
            <button onClick={() => { setShowDiscardConfirm(false); onClose(); }} className="flex-1 h-12 rounded-full bg-red-500 hover:bg-red-600 text-white font-bold text-sm transition-colors">Descartar</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>);
}
